import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/configuracionDeTablas/configTable";
import configTable from "../../models/configTable/configTable";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        service: new service(),
        new: [],
        colums:[],
        tableName:{}

    },

    mutations: {
        setColums(state, data) {
            state.colums = data;
        },
        setAllColums(state, data) {
            state.allColums = data;
        },
        setTableName(state, data) {
            state.tableName = data;
        },
        setNew(state, data){
            state.new = data;
        }
    },
    actions: {
       
        async getColumsTableName(state, tableName) {
            return new Promise(async (resolve, reject) => {
                try {
                    let item = await state.state.service.getColumsTableName(tableName);
                    let itemArray;
                    
                    if (item.jsonData && Object.keys(item.jsonData).length > 0) {
                        itemArray = JSON.parse(item.jsonData);
                    } else {
                        itemArray = [];
                    }
            
                    state.commit("setColums", itemArray);
                    resolve(true);
                } catch (error) {
                    reject(error);
                }
            });
        },
        

        async new(state) {
            return new Promise(async (resolve, reject) => {
                try {
                    await state.state.service.addTableColums(state.state.new).then(() => {
                        let item = state.state.new;
                        let itemArray = JSON.parse(item.json);
                        state.commit("setColums", itemArray);
                        state.commit("setColums", itemArray);
                        resolve(true);
                    });
                } catch (error) {
                    reject(error);
                }
            });
        },

    },

});
